import React, { useState } from "react";
import "./LandingPage.css";
import Header from "../Header/Header";
import CitySelection from "../Reusable/CitySelection/CitySelection";

// List of all Delhi locations (customize as needed)
const delhiLocations = [
  "Hauz Khas",
  "Ardee Mall (Gurugram)",
  "Select Citywalk Mall (Saket)",
  "DLF Avenue (Saket)",
  "Aromathai Wellness (Vasant Vihar)",
  "Starling Edge (Noida Sector 104)",
];

const LandingPage = () => {
  const handleOverlay = () => {};

  // State for selected Delhi location
  const [selectedDelhiLocation, setSelectedDelhiLocation] = useState("");

  return (
    <div className="landing-container">
      <div className="header-height"></div>
      <Header hideMenus={true} />
      <main>
        {/* BG image and quote */}
        <section className="landing-main-bg">
          <div className="landing-quote">
            Authentic wellness. Luxurious treatments. Always respectful, always
            appropriate.
          </div>
          {/* Desktop/Tablet: show form here */}
          <div className="form-row desktop-form">
            <div className="form-section over-bg">
              <h2 className="title">BOOK AN APPOINTMENT</h2>
              <div className="vasant-offer">
                <strong>50% OFF!</strong> Book your first therapy at exclusive prices at our{" "}
                <span className="highlight">Vasant Vihar</span> location.
              </div>
              <p className="call">Call: +91-7042825200</p>
              <p className="or">OR</p>
              <form
                className="appointment-form"
                action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdzbMLHrxEDAs_VUMTqWd4OQgme8tljlH_dK2bt-TYR6rHBZw/formResponse?pli=1"
                method="POST"
                target="_blank"
              >
                <input
                  type="text"
                  name="entry.1382686471"
                  placeholder="Full Name"
                  required
                />
                <input
                  type="email"
                  name="entry.1930129921"
                  placeholder="Email ID"
                  required
                />
                <input
                  type="tel"
                  name="entry.222888119"
                  placeholder="Phone Number"
                  required
                />
                <div className="input-group">
                  <label
                    htmlFor="delhi-location"
                    style={{ fontWeight: 500, color: "#b89b5e" }}
                  >
                    Select Delhi Location
                  </label>
                  <select
                    id="delhi-location"
                    name="entry.1224010482"
                    className="appointment-form"
                    value={selectedDelhiLocation}
                    onChange={(e) => setSelectedDelhiLocation(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px",
                      margin: "8px 0 16px 0",
                      borderRadius: "6px",
                      border: "1.5px solid #D6B981",
                      color: "#7c4d00",
                      fontFamily: "inherit",
                      fontSize: "1rem",
                    }}
                  >
                    <option value="">-- Select Location --</option>
                    {delhiLocations.map((loc) => (
                      <option key={loc} value={loc}>
                        {loc}
                      </option>
                    ))}
                    <option value="Other">Other Location</option>
                  </select>
                </div>
                <button type="submit" className="book-btn">
                  BOOK NOW
                </button>
              </form>
            </div>
          </div>
        </section>
        {/* Mobile: show form as separate section below bg image */}
        <section className="mobile-form-section">
          <div className="form-section over-bg">
            <h2 className="title">BOOK AN APPOINTMENT</h2>
            <div className="vasant-offer">
              <strong>50% OFF!</strong> Book your first therapy at exclusive prices at our{" "}
              <span className="highlight">Vasant Vihar</span> location.
            </div>
            <p className="call">Call: +91-7042825200</p>
            <p className="or">OR</p>
            <form
              className="appointment-form"
              action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdzbMLHrxEDAs_VUMTqWd4OQgme8tljlH_dK2bt-TYR6rHBZw/formResponse?pli=1"
              method="POST"
              target="_blank"
            >
              <input
                type="text"
                name="entry.1382686471"
                placeholder="Full Name"
                required
              />
              <input
                type="email"
                name="entry.1930129921"
                placeholder="Email ID"
                required
              />
              <input
                type="tel"
                name="entry.222888119"
                placeholder="Phone Number"
                required
              />
              <div className="input-group">
                <label
                  htmlFor="delhi-location-mobile"
                  style={{ fontWeight: 500, color: "#b89b5e" }}
                >
                  Select Delhi Location
                </label>
                <select
                  id="delhi-location-mobile"
                  name="entry.1224010482"
                  className="appointment-form"
                  value={selectedDelhiLocation}
                  onChange={(e) => setSelectedDelhiLocation(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    margin: "8px 0 16px 0",
                    borderRadius: "6px",
                    border: "1.5px solid #D6B981",
                    color: "#7c4d00",
                    fontFamily: "inherit",
                    fontSize: "1rem",
                  }}
                >
                  <option value="">-- Select Location --</option>
                  {delhiLocations.map((loc) => (
                    <option key={loc} value={loc}>
                      {loc}
                    </option>
                  ))}
                  <option value="Other">Other Location</option>
                </select>
              </div>
              <button type="submit" className="book-btn">
                BOOK NOW
              </button>
            </form>
          </div>
        </section>
      </main>
      <footer className="footer">
        <div className="our-loc-blok">
          <div className="city-blk">
            <CitySelection handleOverlay={handleOverlay} />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
